import $ from 'jquery';
global.$ = global.jQuery = $;

import "jquery.easing";
import scrollify from "jquery-scrollify";
$.scrollify = scrollify;

global._isSP = undefined;

window.isDebug = true;
window._c_ = function(t){
  if(!isDebug) return;
  console.dir(t);
};

var Init = function(){
  var $window = $(window);
  var $body = $("body").addClass("loaded");
  var $header = $("header");
  var $changePoint = $(".change-point");
  var $logo = $("#logo");

  window.NavColorChange = function(){
    if($window.scrollTop() >= $changePoint.offset().top - ($header.outerHeight() / 2)){
      if(!$header.hasClass("header--scrolled")){
        $header.addClass("header--scrolled");
      }
    }else{
      if($header.hasClass("header--scrolled")){
        $header.removeClass("header--scrolled");
      }
    }
  };
  $window.on("scroll", NavColorChange);
  NavColorChange();

  var $nav = $("nav.nav");
  var _navContentdelayTime = 30;
  $nav.find(".wait").each(function(i){
    var _$this = $(this);
    _$this.attr("data-delay", i * _navContentdelayTime);
  });

  var $navButton = $(".header-nav--btn, .nav--close");
  window.NavOpenClose = function(){
    if($body.hasClass("nav--open")){
      $body.trigger("navclose");
      $body.removeClass("is-modal");
      $nav.stop().animate({opacity: 0}, 200, function(){
        $nav.css({opacity: ""});
        $nav.find('.nav-content').animate({ scrollTop: 0 }, 0);
        ResetAnimate($nav);
        $body.removeClass("nav--open");
      });
    }else{
      $body.trigger("navopen");
      $body.addClass("is-modal");
      $body.addClass("nav--open");
      AnimationStart($nav);
    }
  };
  $navButton.on("click", NavOpenClose);

  // ScrollAnimatiopn
  window.AnimationStart = function($container){
    _c_("AnimationStart");
    var _$wait = $container.find(".wait");
    if(_$wait.length === 0){
      if($.scrollify.isDisabled()){$.scrollify.enable();}
    }else{
      _$wait.each(function(){
        var __$this = $(this);
        var __delay = __$this.data("delay");
        var __timeout = setTimeout(function(){
          __$this
            .removeClass("wait")
            .addClass("animation");
          clearTimeout(__timeout);
        }, __delay)
      });

      if($container !== $nav){
        if($.scrollify.isDisabled()){$.scrollify.enable();}
      }else{
        if(!$.scrollify.isDisabled()){$.scrollify.disable();}
      }
    }
  };

  window.ResetAnimate = function($container){
    _c_("ResetAnimate");
    var _$animate = $container.find(".animation");
    var _$animating = $container.find(".animating");
    _$animate.each(function(){
      var __$this = $(this);
      __$this
        .addClass("wait")
        .removeClass("animation");
    });
    _$animating.each(function(){
      var __$this = $(this);
      __$this
        .addClass("waiting")
        .removeClass("animating");
    });

  };

  window.setAnimation = function(){
    _c_("setAnimation:");
    _c_("scrollTop: " + $(scrollTarget).scrollTop());
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing, _height, mainHeight, mainTop;
    _height = $window.height();
    mainTop = 0;
    timing = _height - (_height / 2);

    for(var i = 0; i < sectionLen; i++){
      var $wait = $($section[i]);
      var offsetTop;

      offsetTop = $wait.offset().top;
      var _delay = $wait.data("delay");
      if(_delay === void 0){
        _delay = 0;
      }
      $wait.delay(_delay).queue(function(){
        var __$this = $(this);
        __$this.removeClass("waiting").addClass('animating');
        __$this.dequeue();
      });
    }
  };

  window.AnimationScroller = function(){
    setAnimation();

    if($body.css("opacity") !== "1"){
      $body.stop().animate({opacity: 1}, 100);
    }
  };

  //$window.on("scroll", AnimationScroller);
  //AnimationScroller();

  var SelectModalOpen = function(event){
    _c_("SelectModalOpen");
    if($body.hasClass("nav--open")){
      return;
    }
    var _$target = $(event.currentTarget);
    var _parentId = _$target.data("modal-id");
    var _id = _$target.data("modal-content");
    var _youtube = _$target.data("modal-youtube");
    var $modal = $("#" + _parentId);
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalBox = $modal.find(".modal-box");
    var $modalClose = $modal.find(".modal--close, .close");
    var $modalContents = $modal.find(".modal-content");
    $body.addClass("is-modal");
    _c_("SelectModalOpen");
    $modalContents.each(function(){
      var __$this = $(this);
      if(__$this.data("modal-content") === _id){
        var _url = __$this.data("modal-url");
        var _color = __$this.data("modal-color");
        var _overlay = __$this.data("modal-overlay");
        var _opacity = __$this.data("modal-opacity") * 1;

        _c_(_youtube);

        if(_url !== void 0){
          __$this.css({
            "background": "url(" + _url + ") center center / 100% 100%"
          });
        }else if(_color !== void 0){
          __$this.css({
            "background": _color
          });
        }

        if(_youtube !== void 0){
          var __$movie = __$this.find(".movie").empty();
          var __$yt = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + _youtube + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
          __$movie.append(__$yt);
        }

        __$this.addClass("modal-content--open");
        $modalOverlay.css({
          "background": _overlay,
          opacity: _opacity,
        });
      }
    });

    $modal.css({display: "block"});
    $(".modal-wrap").scrollTop(0);
    if($window.height() > $modalBox.height()){
      $modalBox.addClass("position-middle");
    }else{
      $modalBox.removeClass("position-middle");
    }
    $modalOverlay.on("click", SelectModalClose);
    $modalClose.on("click", SelectModalClose);
  };

  var SelectModalClose = function(){
    _c_("SelectModalClose");
    var $modal = $(".modal");
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalClose = $modal.find(".modal--close, .close");
    var $modalBox = $modal.find(".modal-box");
    var $modalContents = $modal.find(".modal-content");
    var _youtube = $modalContents.data("modal-youtube");
    if(_youtube !== void 0){
      $modalContents.find(".movie").empty();
    }
    $modal.css({display: ""});
    $body.removeClass("is-modal");
    $modalContents.each(function(){
      var __$this = $(this);
      __$this
        .css({"background": ""})
        .removeClass("modal-content--open");
    });
    $modalOverlay.css({
      "background": "",
      opacity: "",
    });

    $modalBox.removeClass("position-middle");

    //$modalOverlay.off("click", SelectModalClose);
    $modalClose.off("click", SelectModalClose);
  };

  $body.on("click", ".modal--btn", SelectModalOpen);

  $(".pagetop").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 1000, "easeInOutCirc");
  });

  // for SubContent
  if($body.attr("id") !== "top"){
    var $slide = $("#slide_change");
    var $slideImages = $slide.find("img");

    var slideTimer = setInterval(function(){
      $slideImages.each(function(){
        var $this = $(this);
        if($this.hasClass("current")){
          $this.removeClass("current");
        }else{
          $this.addClass("current");
        }
      });
    }, 7000);
  }

  var Resize = function(){
    if($window.width() < 829){
      _isSP = true;
    }else{
      _isSP = false;
    }
  };
  $window.on("resize", Resize);
  Resize();


  $(".header-lang .current").on("click", function(){
    return false;
  });
};

window.addEventListener("load", Init);
